import en from "vuetify/lib/locale/en"

export default {
  ...en,
  appbar: {
    about: "About Us",
    contact: "Contact",
    secondopinionFaq: "FAQ"
  },
  bottomsheet: {
    imprint: "Imprint",
    generalTerms: "General terms and conditions of business",
    privacyPolicy: "Privacy Policy"
  },
  patient: {
    insuranceNumber: "Insurance number",
    title: "Title",
    firstName: "First Name",
    lastName: "Last Name",
    birthDate: "Birthdate",
    gender: "Gender",
    street: "Street",
    zipCode: "Zip Code",
    city: "City",
    country: "Country",
    telephone: "Telephone Number"
  }
}
